/* ================================================================ */
// USER TOOLBAR COMPONENT | UserToolbar.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import SvgIcon from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
// Auth0
import { useAuth0 } from '../../../auth0/auth0';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(() => ({
    root: {
        zIndex: 10000,
        display: 'flex',
        position: 'fixed',
        top: 0,
        right: '2em',
        height: '4em',
    },
    user: {
        margin: '1em'
    }
}));
/* ========================================== */
/**
 * User Toolbar
 * ------------
 * Login/Logout and current user display
 *
 * @component
 * @param {object} props component properties
 */
const UserToolbar = (props) => {
    const classes = useStyles();
    const {isAuthenticated, loginWithRedirect, logout, loading, user} = useAuth0();
    const handleProfileClick = () => {
        console.log(user);
    };
    return !loading && (
        <Paper className={classes.root}>
            {console.log(user)}
            {isAuthenticated && user &&
                <div className={classes.user}>
                    <Chip
                        avatar={<Avatar alt={user.nickname} src={user.picture} />}
                        label={user.name}
                        color="primary"
                        onClick={handleProfileClick}
                        variant="outlined"
                    />
                </div>
            }
            <Divider orientation="vertical" flexItem />
            {!isAuthenticated ? (
                <Button startIcon={<LoginIcon />} color="primary" onClick={() => loginWithRedirect({})}>Login</Button>
            ) : (
                <Button startIcon={<LogoutIcon />} onClick={() => logout()}>Logout</Button>
            )}
        </Paper>
    );
};
const LoginIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M10,17V14H3V10H10V7L15,12L10,17M10,2H19A2,2 0 0,1 21,4V20A2,2 0 0,1 19,22H10A2,2 0 0,1 8,20V18H10V20H19V4H10V6H8V4A2,2 0 0,1 10,2Z" />
        </SvgIcon>
    );
};
const LogoutIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
        </SvgIcon>
    );
};
/* ========================================== */
// Export
/* ========================================== */
export default UserToolbar;